<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Diversion Books<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © 1994 by Deborah Chester<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">First Diversion Books edition January 2015<br/>
  ISBN: 978-1-62681-<span style="text-align: justify;">583-4</span></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1 class="sigil_not_in_toc">More from Deborah Chester</h1>
<p class="sectiontop" style="text-align:center"><span href="#/Text/morefrom" title="Link target outside of Sample"><b>Time Trap Series</b><br/>
  Time Trap<br/>
  Showdown<br/>
  Pieces of Eight<br/>
  Restoration<br/>
  Turncoat<br/>
  Termination</span></p>
<p class="sectiontop" style="text-align:center"><span href="#/Text/morefrom" title="Link target outside of Sample"><b>Ruby Throne Series</b><br/>
  Reign of Shadows<br/>
  Shadow War<br/>
  Realm of Light</span></p>
<p class="sectiontop" style="text-align:center"><span href="#/Text/morefrom" title="Link target outside of Sample"><b>Anthi Series</b><br/>
  The Children of Anthi<br/>
  Requiem for Anthi</span></p>
<p class="sectiontop" style="text-align:center"><span href="#/Text/morefrom" title="Link target outside of Sample">The Omcri Matrix<br/>
  The Goda War</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_copyrightPage.vue?1f5a910d